<template>
  <div class="site-search-group">
    <ipub-input :value="val"
                v-if="!tag"
                :style="{width: `calc(100% - ${clear?'120px':'60px'})`}"
                :placeholder="placeholder"
                @keypress.enter.native="handleSearch"
                @input="handleInput" />
    <ipub-input v-else
                :value="val"
                :tag="tag"
                :style="{width: `calc(100% - ${clear?'120px':'60px'})`}"
                :placeholder="placeholder"
                @input="handleInput" />
    <ipub-button class="search-group-button"
                 @click="handleSearch"
                 type="primary"
                 icon="iconSearch" />
    <ipub-button v-if="clear"
                 class="search-group-button"
                 @click="handleClear"
                 icon="iconClear" />
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Array],
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    clear: {
      type: Boolean,
      default: true
    },
    tag: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      val: ''
    }
  },
  watch: {
    value () {
      this.val = this.value
    }
  },
  mounted () {
    this.val = this.value
  },
  methods: {
    handleInput (val) {
      this.val = val
      this.$emit('input', val)
    },
    handleSearch () {
      this.$emit('search', this.val)
    },
    handleClear () {
      this.$emit('clear', this.val)
      this.val = ''
    }
  }
}
</script>

<style lang="scss" scoped>
.site-search-group {
  display: flex;
  justify-content: space-between;
  .search-group-button {
    width: 40px;
    padding: 0;
    font-size: 28px;
    margin-left: 20px;
  }
}
</style>
